import { Transform, Type } from "class-transformer";
import { UserDto } from "../users/user.dto";
import { ExpenseSheetStatusEnum } from "@altertec_gparn/lib";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { parseApiDate } from "@/utils/dates/dateFormats";
import { toEuros } from "@/utils/numberUtils";

export class ExpenseSheetDto extends BaseEntityDto {
  @Type(() => UserDto)
  user: UserDto;

  userId: string;

  @Transform(({ value }) => parseApiDate(value))
  startDate: Date;

  @Transform(({ value }) => parseApiDate(value))
  endDate: Date;

  status: ExpenseSheetStatusEnum;

  @Transform(({ value }) => parseApiDate(value))
  confirmedAt?: Date;

  @Transform(({ value }) => toEuros(value))
  total: number;
}
